import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const DeleteCustomColorIcon: TIconType = (props?: IIconProps) => {
	const width = props?.width || '24';
	const height = props?.height || '24';

	return (
		<svg
			data-testid='delete'
			fill='none'
			height={height}
			viewBox='0 0 24 24'
			width={width}
			{...props?.innerSvgProps}
		>
			<path
				d='M20.25 5.25H3.75'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8.25 2.25H15.75'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default DeleteCustomColorIcon;
